module.exports = __webpack_public_path__ + "e1e7041a2f8bf91a58eb1ade815a0a36.svg";